import { post, get } from '../../http/axios';

// 2. 获取用户信息
export const getList = (aiCheckId, appConfig) => {
  return get(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/viewer/getAiList?aiCheckId=' +
    aiCheckId
  ).catch(err => {
    console.log(err);
    return err;
  });
};
export const getAnalysisResultList = (aiCheckId, aiInfoId, appConfig) => {
  return get(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/viewer/getAiResultById?aiCheckId=' +
    aiCheckId +
    '&aiInfoId=' +
    aiInfoId
  ).catch(err => {
    return err;
  });
};

export const confirmAiResult = (payload, appConfig) => {
  return post(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/viewer/confirmAiResult',
    payload
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const saveAiCheck = (payload, appConfig) => {
  // let payload = { "code": "1234", "name": "yyyy" };
  return post(
    appConfig.servers.apiServer[0].baseUrl + 'yinghe-api/viewer/saveAiCheck',
    payload
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const getAiList = (dicCheckId, pageSize, currentPage, appConfig) => {
  return get(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/userVsAiSetting/availableAiList?pageSize=' +
    pageSize +
    '&currentPage=' +
    currentPage +
    '&dicCheckId=' +
    dicCheckId
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const getAiPathList = (dicCheckId, pageSize, currentPage, appConfig) => {
  return get(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/userVsAiSetting/aiPathSetting?pageSize=' +
    pageSize +
    '&currentPage=' +
    currentPage +
    '&dicCheckId=' +
    dicCheckId
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const getDicCheckList = appConfig => {
  return get(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/userVsAiSetting/dicCheck'
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const getDicCheckListVsAi = appConfig => {
  return get(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/userVsAiSetting/dicCheckVsAi'
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const saveAiStatus = (payload, appConfig) => {
  return post(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/userVsAiSetting/enableAi',
    payload
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const saveAiVisible = (payload, appConfig) => {
  return post(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/userVsAiSetting/enableView',
    payload
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const addAi = (payload, appConfig) => {
  return post(
    appConfig.servers.apiServer[0].baseUrl + 'yinghe-api/userVsAiSetting/addAi',
    payload
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const getLessonsTypeList = (name, appConfig) => {
  return get(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/userVsAiSetting/listLessonsType?name=' +
    name
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const getAiBasicSetting = (aiInfoId, dicCheckId, appConfig) => {
  return get(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/aiBasicSetting/getBasicAndResultSetting?aiInfoId=' +
    aiInfoId +
    '&dicCheckId=' +
    dicCheckId
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const addBasicSetting = (payload, appConfig) => {
  return post(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/aiBasicSetting/saveBasicAndResultSetting',
    payload
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const updateBasicSetting = (payload, appConfig) => {
  return post(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/aiBasicSetting/updateBasicAndResultSetting',
    payload
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const getLessonsTypeListByBasicSetting = appConfig => {
  return get(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/aiFilter/getLessonsTypes'
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const getAiFilterCondition = (projectCode, appConfig) => {
  return get(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/aiFilter/getFilterCondition?projectCode=' +
    projectCode
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const getAiFilterSetting = (aiBasicSettingId, appConfig) => {
  return get(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/aiFilter/getFilterSetting?aiBasicSettingId=' +
    aiBasicSettingId
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const addFilterSetting = (payload, appConfig) => {
  return post(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/aiFilter/saveFilterSetting',
    payload
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const getFirstClassOrgan = (device, appConfig) => {
  return get(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/organDeviceReference/firstClassOrgan?isAll=all&device=CT'
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const getSecondClassOrgan = (firstOrganId, appConfig) => {
  return get(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/organDeviceReference/secondClassOrgan?isAll=no&firstOrganId=' +
    firstOrganId
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const getCheckItem = (secondOrganId, appConfig) => {
  return get(
    appConfig.servers.apiServer[0].baseUrl +
    'yinghe-api/organDeviceReference/checkItem?isAll=no&secondOrganId=' +
    secondOrganId
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const getResultSetting = (id, appConfig) => {
  return get(
    appConfig.servers.apiServer[0].baseUrl +
    '/yinghe-api/aiBasicSetting/getResultSetting?lesionsId=' +
    id
  ).catch(err => {
    console.log(err);
    return err;
  });
};
